import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Pbi from './Pbi';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Pbi />
  </React.StrictMode>
);